import React from "react";
import "./App.css";

function App() {
  return (
    <div>
      <div id="about">
        <h1>Cobresun</h1>
        <p>
          <b>🎂 Birthday: </b>June 24, 2014 (when the name first came into
          existence)
        </p>
        <p>
          <b>🎯 Mission: </b>Make a video game 🎮
        </p>
        <b>👨‍👨‍👦‍👦 Members:</b>
        <ul>
          <li>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://github.com/cole-adams"
            >
              Cole Adams
            </a>
          </li>
          <li>
            <a rel="noopener noreferrer" target="_blank" href="https://bnor.me">
              Brian Norman
            </a>
          </li>
          <li>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://wesley-tang.github.io"
            >
              Wesley Tang
            </a>
          </li>
          <li>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://sunnynagam.github.io"
            >
              Sunny Nagam
            </a>
          </li>
        </ul>

        <img src="naming-moment.png" alt="The moment Cobresun got its name." />
      </div>

      <h1>Projects</h1>
      <p>
        Our projects on{" "}
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://github.com/Cobresun"
        >
          GitHub
        </a>
        !
      </p>
    </div>
  );
}

export default App;
